import styled from "styled-components";

export const IconContainer = styled.span`
    cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
    text-align: center;
`;
